import React from 'react';
import { List } from "../ecosystem";
import FavoriteDrHeadings from "./FavoriteDrHeadings";

const FavDocTips = () => {
    return (<div className="fav-doc-tips">
        <FavoriteDrHeadings heading="Tips for choosing a doctor:" />
        <List
            list={[
                "Ask for recommendations",
                "Insurances accepted - are they in network?",
                "Convenience - how near or far are they?",
                "Availability - are they taking new patients?",
                "Patient experience - how do others rate them?"
            ]}
        ></List>
    </div>);
}
export default FavDocTips;